<div class="login-container">
  <section>
    <app-loading *ngIf="isLoading" />
    <app-login-by-user-password [username]="username" />
  </section>
</div>
